import { Timestamp } from 'firebase/firestore';

export enum JOB_TYPE {
  OBJECT_IMPORT = 'OBJECT_IMPORT',
  CHECKLIST_IMPORT = 'CHECKLIST_IMPORT',
  PDF_REGENERATION = 'PDF_REGENERATION',
  FILE_EXPORT = 'FILE_EXPORT'
}

export enum JOB_STATUS {
  QUEUED = 'QUEUED',
  IN_PROGRESS = 'IN_PROGRESS',
  SAVING_FIRESTORE = 'SAVING_FIRESTORE',
  SAVING_RTDB = 'SAVING_RTDB',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum JOB_TYPES {
  JOB = 'JOB',
  JOB_GROUP = 'JOB_GROUP',
  JOB_GROUP_STATE = 'JOB_GROUP_STATE',
}

export type JobsMap = { [key: string]: Job };

export interface Job {
  id: string;
  jobIdentifier?: string;
  type: JOB_TYPES.JOB;
  jobType: JOB_TYPE;
  projectId: string;
  jobGroupId: string;
  filepath: string;
  state: JobState;
  itemCount: number;
  fileUrl?: string;
  payloadMeta?: PayloadMeta;
}

export interface PayloadMeta {
  objectId?: string;
  checklistId?: string;
  fileId?: string;
}

export interface JobGroupFailure {
  jobId: string;
  jobIdentifier?: string;
  objectId?: string;
  checklistId?: string;
  fileId?: string;
  errorMessage?: string;
}

export interface JobState {
  status: JOB_STATUS;
  timestamp: Timestamp;
  progressCount?: number;
  progress?: number;
  errorMessage?: string;
}

export interface RtJobState {
  id?: string;
  status: JOB_STATUS;
  progress: number;
  errorMessage?: string;
}

export interface JobFrontendState {
  status: JOB_STATUS;
  progress: number;
  totalCount: number;
}

export interface JobGroupState {
  id?: string;
  type?: JOB_TYPES.JOB_GROUP_STATE;
  status: JOB_STATUS;
  timestamp: Timestamp;
  progressCount: number;
  progress: number;
  totalCount: number;
  jobCount: number;
}

export interface RtJobGroup {
  id?: string;
  jobType: JOB_TYPE;
  totalCount: number;
  jobCount: number;
  createdAt: Timestamp;
  status?: JOB_STATUS;
  progress?: number;
  progressCount?: number;
  user: {
    id: string;
    email: string;
    name: string;
  };
}

export interface JobGroup {
  id: string;
  projectId: string;
  type: JOB_TYPES.JOB_GROUP;
  jobType: JOB_TYPE;
  totalCount: number;
  jobCount: number;
  createdAt: Timestamp;
  state?: JobGroupState;
  user: {
    id: string;
    email: string;
    name: string;
  };
  jobs?: JobsMap;
  completedAt?: Timestamp;
  payloadsCleanedAt?: Timestamp;
  failedCount?: number;
  succeededCount?: number;
  failures?: JobGroupFailure[];
}
